import React from 'react';
import { useIntl } from 'react-intl';

import { useTopCategories } from '../../hooks';

import { Container, RelatedJob, RelatedJobsWrapper, Title } from './related-jobs.styles';

export const RelatedJobs: React.FC = () => {
  const { formatMessage } = useIntl();
  const { relatedJobRolesByJobRole } = useTopCategories();

  return (
    <>
      {relatedJobRolesByJobRole.length > 0 ? (
        <Container>
          <Title size="large" sizeConfined="xlarge">
            {formatMessage({ id: 'XJM_JOBS_SEO_ROLE_RELATED_JOBS_HEADLINE' })}
          </Title>
          <RelatedJobsWrapper>
            {relatedJobRolesByJobRole.map((item) => (
              <RelatedJob key={item.seoName} href={`/jobs/t-${item.seoName}`}>
                {item.name}
              </RelatedJob>
            ))}
          </RelatedJobsWrapper>
        </Container>
      ) : null}
    </>
  );
};
